import { PREVENT_SCROLL_CLASS_NAME } from '../config/consts';

export const preventScroll = (classToApply: string, shouldRemoveClass?: boolean) => shouldRemoveClass
  ? document.querySelector(classToApply)?.classList.remove(PREVENT_SCROLL_CLASS_NAME)
  : document.querySelector(classToApply)?.classList.add(PREVENT_SCROLL_CLASS_NAME);
